export default {"src":"/_next/static/media/ArrowDown1.f6a7af6e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};